import styled, { css } from 'styled-components';
import { rem } from '../../utils/style';
import { COLORS } from '../../constants/style/color';

export const ParticipantCard = styled.div`
  padding: ${rem(9)} ${rem(12)} ${rem(42)} ${rem(8)};
  margin-top: ${rem(32)} 0 ${rem(12)} 0;

  .cardTagCount {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .card-form {
    padding: ${rem(26)} ${rem(12)} ${rem(0)} ${rem(24)};

    .employeeAddress {
      padding-bottom: ${rem(12)};
    }
    .otherInfo {
      padding: ${rem(16)} 0;
    }
  }
`;

export const TransactionDetail = styled.div`
  /* padding-top: ${rem(30)}; */
  .title {
    margin-top: 2rem;
    margin-left: 2rem;
    margin-bottom: 18px;
    color: ${COLORS.Gray};
    font-size: 2rem;
  }
  .rowDetail {
    /* border-bottom: 1px solid ${COLORS.CulturedWhite}; */
    /* margin-left: 2rem; */
    margin-top: ${rem(18)};
  }
`;

export const TransactionDivider = styled.div`
  /* margin-top: ${rem(4)}; */
  margin-bottom: ${rem(18)};
  border-bottom: ${rem(1)} solid ${COLORS.CulturedWhite};
`;

export const TransactionSingleDetailBlock = styled.div`
  padding-bottom: ${rem(18)};
  display: flex;
  width: 100%;
  align-items: center;

  .material-symbols-outlined,
  .material-symbols-sharp {
    font-size: ${rem(16)};
    color: ${COLORS.SpanishGray};
    margin-left: ${rem(5)};
  }

  .list {
    border-bottom: 1px solid ${COLORS.CulturedWhite};
    gap: ${rem(50)};
    align-items: flex-start;

    &:last-child {
      border-bottom: none;
    }

    &-icon {
      display: flex;
      align-items: center;
      gap: ${rem(5)};
      padding: ${rem(16)} 0;

      .material-symbols-outlined {
        font-size: ${rem(20)};
        color: ${COLORS.SpanishGray};
      }
    }

    &-content {
      padding: ${rem(16)} 0;

      .profile-date {
        margin-top: ${rem(12)};
      }

      .profile-url {
        font-size: ${rem(14)};
        line-height: ${rem(18)};
        color: ${COLORS.Iris};
        text-decoration: underline;

        &:hover {
          color: ${COLORS.Blue};
        }
      }
    }
  }

  .material-symbols-outlined-success {
    color: ${COLORS.Green};
  }

  .material-symbols-outlined-default {
    color: ${COLORS.SpanishGray};
  }

  .material-symbols-outlined-error {
    color: ${COLORS.Red};
  }

  .material-symbols-outlined-success,
  .material-symbols-outlined-default,
  .material-symbols-outlined-error {
    font-size: ${rem(20)};
  }

  .profile-employeeWrapper {
    display: flex;
    flex-direction: column;
    gap: ${rem(5)};
    padding: ${rem(18)} ${rem(0)};
    width: 100%;
  }

  .profile-mainTitle {
    font-weight: 500;
    font-size: ${rem(16)};
    color: ${COLORS.Black};
  }
  .profile-subTitle {
    font-weight: 400;
    font-size: ${rem(14)};

    color: ${COLORS.Gray};
  }

  > span {
    font-size: 24px;
    color: ${COLORS.SpanishGray};
    flex-direction: column;
    margin-right: ${rem(10)};
  }
  .detailLabel {
    margin-bottom: 4px;
    color: ${COLORS.Gray};
  }
`;

export const TransactionPageWrapper = styled.div`
  .page {
    gap: ${rem(32)};

    h3 {
      max-width: ${rem(165)};
    }

    &-title {
      position: relative;
      padding-left: ${rem(12)};
      width: ${rem(164)};
      margin-bottom: ${rem(24)};

      &::before {
        content: '';
        position: absolute;
        height: 100%;
        width: ${rem(3)};
        background-color: ${COLORS.Purple};
        left: 0;
      }

      h3 {
        font-weight: 600;
      }
    }

    .profile-info {
      flex-grow: 1;
    }
  }
  .tab-container {
    margin-top: ${rem(52)};
  }
`;

export const TransactionPageHeader = styled.div`
  margin-bottom: ${rem(24)};

  h3 {
    margin-bottom: ${rem(5)};
  }

  span {
    color: ${COLORS.Gray};
  }
`;

export const ReleaseNameAndStyle = styled.div`
  display: flex;
  gap: ${rem(16)};
  justify-content: space-between;
  margin-top: 2rem;
  align-items: flex-start;
  flex-wrap: nowrap;
  .first {
    flex: 1 1 35%;
    min-width: ${rem(160)};
  }
  .second {
    flex: 0 0 20%;
    min-width: ${rem(150)};
  }
  .third {
    flex: 0 0 auto;
    min-width: ${rem(320)};
    margin-top: ${rem(2)};
  }
`;

export const TaxBracketAccordingContainer = styled.div`
  background: ${COLORS.Grey400Transparent};
  /* opacity: 0.5; */
  border-bottom: 1px solid ${COLORS.LightGray};
  border-radius: 6px 6px 0px 0px;
  padding: ${rem(13)} ${rem(15)};
  font-weight: 500;
`;

export const TaxBracketAccordingValue = styled.div`
  height: auto;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 7px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.SpanishGray};
    border-radius: 7px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  background: ${COLORS.Grey100Transparent};
  border-radius: 0px 0px 6px 6px;
  padding: ${rem(21)} ${rem(32)};
`;
export const TaxBracketHeaders = styled.div`
  padding-bottom: ${rem(15)};
  border-bottom: 1px solid ${COLORS.LightGray};
`;
export const TaxBracketValue = styled.div`
  padding: ${rem(21)} ${rem(0)} ${rem(21)} ${rem(0)};
  border-bottom: 1px solid ${COLORS.LightGray};
  &:last-child {
    border-bottom: 0;
  }
`;

export const TotalContainer = styled.div`
  border-radius: 6px;
  background: ${COLORS.Grey100Transparent};
  height: ${rem(76)};
  margin-top: ${rem(18)};
  padding: ${rem(0)} ${rem(19)};
`;
export const SummeryBlock = styled.div`
  margin-top: ${rem(18)};
  padding: ${rem(20)};
  border-radius: ${rem(6)};
  border: ${rem(1)} solid ${COLORS.CulturedWhite};
`;

export const ResizeTableHeader = styled.div`
  .height-identifier {
    min-height: ${rem(420)};
  }
`;
